/* global document */
export default function dashboardIframeDirective() {
  console.log('app.components.dashboard.dashboardIframeDirective created');
  return {
    restrict: 'E',
    link: (scope, elem) => {
      _link(scope, elem,);
    },
    scope: {
      content: '='
    }
  };
}

function _link(scope, element) {
  const iframe = document.createElement('iframe');
  const element0 = element[0];
  element0.appendChild(iframe);
  // const body = iframe.ownerDocument.body;

  scope.$watch('content', () => {
    iframe.contentWindow.document.open('text/htmlreplace');
    iframe.contentWindow.document.write(scope.content);
    iframe.contentWindow.document.close();
    // body.innerHTML = scope.content;
  });
}

dashboardIframeDirective.$inject = [
];
